import { DevicePlatform } from "@speakai/shared";
import { apiClient } from "@/lib/api/client";

const INTERCOM_APP = "speak-web";
const INTERCOM_PLATFORM = DevicePlatform.WEB;

/** Fetches the signed Messenger token for the signed-in user; null when the call fails so callers boot anonymous. */
export async function fetchIntercomJwt(): Promise<string | null> {
  const query = new URLSearchParams({
    platform: INTERCOM_PLATFORM,
    app: INTERCOM_APP,
    appVersion: __APP_VERSION__,
  });
  try {
    const res = await apiClient.get<{ intercomJwt?: string }>(`/auth/intercomJwt?${query.toString()}`);
    return res.success && res.data?.intercomJwt ? res.data.intercomJwt : null;
  } catch {
    return null;
  }
}
